/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export const union_center_info = createAsyncThunk(
  'Saada/saadaUnionAnchorInvite/union_center_info',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/union_center_info',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const get_member_info_by_show_id = createAsyncThunk(
  'Saada/saadaUnionAnchorInvite/get_member_info_by_show_id',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/account/get_member_info_by_show_id',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const union_invite_anchor = createAsyncThunk(
  'Saada/saadaUnionAnchorInvite/union_invite_anchor',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/union_invite_anchor',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const union_deal_anchor_apply = createAsyncThunk(
  'Saada/saadaUnionAnchorInvite/union_deal_anchor_apply',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/union_deal_anchor_apply',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

const union_anchor_apply_list = async (p: any, store: any) => {
  const resp = await http.post(
    '/live/hiya_socialize/union_anchor_apply_list',
    {
      ...store.getState().env.deviceinfo,
      ...p,
    },
    {
      xcErrorToast: true,
    }
  )
  return resp.data.data?.list || []
}
export const union_anchor_apply_list_wait = createAsyncThunk(
  'Saada/saadaUnionAnchorInvite/union_anchor_apply_list_wait',
  (p: any, store: any) => union_anchor_apply_list({type: 2, status: 0}, store)
)
export const union_anchor_apply_list_agree = createAsyncThunk(
  'Saada/saadaUnionAnchorInvite/union_anchor_apply_list_agree',
  (p: any, store: any) => union_anchor_apply_list({type: 2, status: 1}, store)
)
export const union_anchor_apply_list_dis = createAsyncThunk(
  'Saada/saadaUnionAnchorInvite/union_anchor_apply_list_dis',
  (p: any, store: any) => union_anchor_apply_list({type: 2, status: 3}, store)
)
export const union_anchor_apply_list_invite = createAsyncThunk(
  'Saada/saadaUnionAnchorInvite/union_anchor_apply_list_invite',
  (p: any, store: any) => union_anchor_apply_list({type: 1}, store)
)

const initialState: {
  home: any
  wait: Array<any>
  agree: Array<any>
  dis: Array<any>
  invite: Array<any>
} = {
  home: {},
  wait: [],
  agree: [],
  dis: [],
  invite: [],
}

export function useSaadaUnionAnchorInvite() {
  return useSelector((store) => store.SaadaUnionAnchorInvite)
}

export const SaadaUnionAnchorInviteSlice = createSlice({
  name: 'SaadaUnionAnchorInvite',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(union_center_info.fulfilled, (state, action) => {
      Object.assign(state.home, action.payload)
    })
    builder.addCase(union_anchor_apply_list_wait.fulfilled, (state, action) => {
      Object.assign(state, {wait: action.payload})
    })
    builder.addCase(
      union_anchor_apply_list_agree.fulfilled,
      (state, action) => {
        Object.assign(state, {agree: action.payload})
      }
    )
    builder.addCase(union_anchor_apply_list_dis.fulfilled, (state, action) => {
      Object.assign(state, {dis: action.payload})
    })
    builder.addCase(
      union_anchor_apply_list_invite.fulfilled,
      (state, action) => {
        Object.assign(state, {invite: action.payload})
      }
    )
  },
})

export default SaadaUnionAnchorInviteSlice.reducer
export const SaadaUnionAnchorInviteActions = SaadaUnionAnchorInviteSlice.actions
